import { useDroppable } from "@dnd-kit/core";
import { cn } from "@sorcery/ui";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  OnClickLink,
} from "@sorcery/ui";
import { useRouter } from "next/router";
import { MdOutlineMoreHoriz } from "react-icons/md";
import { TbFolder } from "react-icons/tb";
import { ModalTypeEnum, useModal } from "~/providers/ModalProvider";
import type { FolderType } from "~/types/folder";

type Props = {
  folder: FolderType;
};

export const FolderPreview = ({ folder }: Props) => {
  const { query: routerParams, push } = useRouter();

  const { openModal } = useModal();

  const onRename = (folderId: string) => {
    openModal(ModalTypeEnum.RENAMEFOLDER, { folderId });
  };

  const onDelete = (folderId: string) => {
    openModal(ModalTypeEnum.FOLDERDELETE, { folderId });
  };

  const { isOver, setNodeRef } = useDroppable({
    id: folder.id,
  });

  return (
    <div
      ref={setNodeRef}
      key={folder.id}
      className={cn(
        "border border-line-color sm:border-transparent p-2 rounded-md bg-background cursor-pointer transition animate-in fade-in flex flex-wrap justify-between hover:text-white hover:bg-secondary",
        isOver && "bg-text-color text-secondary",
      )}
    >
      <OnClickLink
        className="hover:scale-[101%] grow "
        onClick={() =>
          void push(
            {
              query: {
                ...routerParams,
                folder: folder.id,
              },
            },
            undefined,
            {
              shallow: true,
            },
          )
        }
      >
        <div className="flex items-center justify-between">
          <div className="ml-0.5 mr-2 flex items-center">
            <div className="flex">
              <TbFolder size={16} className="mt-0.5 mr-2" />
              <div className="truncate max-w-48 mr-2">{folder.name}</div>
              <div className="opacity-70">({folder.decks.length})</div>
            </div>
          </div>
        </div>
      </OnClickLink>

      <div className="ml-2 flex items-center">
        <DropdownMenu modal={false}>
          <DropdownMenuTrigger asChild className="hover:opacity-60">
            <Button variant="minimal" className="py-0 pr-1">
              <MdOutlineMoreHoriz size={18} />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent side="bottom" align="end">
            <DropdownMenuItem onClick={() => onRename(folder.id)}>Rename</DropdownMenuItem>
            <DropdownMenuItem
              onClick={() => onDelete(folder.id)}
              className="hover:!bg-red hover:!text-white"
            >
              Delete
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
};
